<template>
<canvas id="arrows" class="arrows" :style="style"></canvas>
</template>
<script>
export default {
    data() {
        return {
            show: false,
            context: '',
            x: 0,
            y: 0
        }
    },
    computed: {
        style() {
            return {
                top: this.y - 100 + 'px',
                display: this.show ? 'block' : 'none'
            }
        }
    },
    methods: {
        getXY(event) {
            let touch = event.touches[0]
            this.x = touch.clientX
            this.y = touch.clientY
        },
        touchstart(event) {
            this.getXY(event)
            if (this.x < 30) {
                this.show = true
                this.render()
            } else {
                this.show = false
            }
        },
        touchmove(event) {
            this.getXY(event)
            this.render()
        },
        touchend() {
            if (this.x > 90 && this.show) {
                this.$router.go(-1)
            }
            this.x = 0
            this.show = false
        },
        render() {
            let x = this.x / 3

            if (x > 25) {
                x = 25
            }
            let n = ~~(x / 5)
            let color = `rgba(30,30,30,${x / 25})`
            this.context.clearRect(0, 0, 30, 210)
            this.context.fillStyle = color
            this.context.beginPath()
            this.context.moveTo(0, 0)
            this.context.bezierCurveTo(5, 70, x, 70, x, 100)
            this.context.moveTo(x, 100)
            this.context.bezierCurveTo(x, 140, 5, 140, 0, 210)
            this.context.lineTo(0, 0)
            this.context.fill()
            // 箭头
            this.context.moveTo(2 * n, 93)
            this.context.lineTo(3 * n, 100)
            this.context.lineTo(2 * n, 107)
            this.context.lineWidth = 2
            this.context.strokeStyle = '#fff'
            this.context.stroke()
        }
    },
    mounted() {
        window.addEventListener('touchstart', this.touchstart)
        window.addEventListener('touchmove', this.touchmove)
        window.addEventListener('touchend', this.touchend)
        let canvas = document.getElementById('arrows')
        canvas.width = 30
        canvas.height = 210
        this.context = canvas.getContext('2d')
    }
}
</script>
<style lang="scss" scoped>
.arrows {
    position: fixed;
    width: 30px;
    height: 210px;
    left: -2px;
}
</style>

